import { useContext, useLayoutEffect, useRef, useState } from "react";
import {
  FaCog,
  FaDollarSign,
  FaFileAlt,
  FaHistory,
  FaHourglassHalf,
  FaLink,
  FaPlay,
  FaQuestionCircle,
  FaShoppingCart,
  FaTachometerAlt,
} from "react-icons/fa";
import Navbar from "./../../components/Navbar/Navbar";
import { ActionItems } from "./ActionItems";
import { Clients } from "./Clients";
import { DashBoard } from "./Dashboard";
import { HelpCenter } from "./HelpCenter";
import "./HomePage.css";
import { UserContext } from "../../context/UserContext";
import { ActiveRequests } from "./ActiveRequests";
import PendingConfirmation from "./PendingConfirmation/PendingConfrmation";
import CompleteRequests from "./CompleteRequests/CompleteRequests";
import Transactions from "./Transactions/Transactions";
import Configurations from "./Configurations/Configurations";
import NobelLink from "./NobelLink/NobelLink";

const renderActivePage = (page) => {
  switch (page) {
    case "Dashboard":
      return <DashBoard />;
    case "Clients":
      return <Clients />;
    case "Action Items":
      return <ActionItems />;
    case "Help Center":
      return <HelpCenter />;
    case "Active Requests":
      return <ActiveRequests />;
    case "Pending Confirmation":
      return <PendingConfirmation />;
    case "Transactions":
      return <Transactions />;
    case "Complete Requests":
      return <CompleteRequests />;
    case "Configurations":
      return <Configurations />;
    case "Nobel Link":
      return <NobelLink />;
    default:
      return <div>Select a page</div>;
  }
};

const Sidebar = ({ role, onClick, activePage }) => {
  return (
    <div className="sidebar">
      {role === "medical" ? (
        <>
          <div
            className={`sidebar-item ${
              activePage === "Active Requests" ? "active" : ""
            }`}
            onClick={() => onClick("Active Requests")}
          >
            <FaPlay /> Active Requests
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Pending Confirmation" ? "active" : ""
            }`}
            onClick={() => onClick("Pending Confirmation")}
          >
            <FaHourglassHalf /> Pending Confirmation
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Transactions" ? "active" : ""
            }`}
            onClick={() => onClick("Transactions")}
          >
            <FaDollarSign /> Transactions
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Complete Requests" ? "active" : ""
            }`}
            onClick={() => onClick("Complete Requests")}
          >
            <FaHistory /> Complete Requests
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Configurations" ? "active" : ""
            }`}
            onClick={() => onClick("Configurations")}
          >
            <FaCog /> Configurations
          </div>
          {/* <div
            className={`sidebar-item ${
              activePage === "Nobel Link" ? "active" : ""
            }`}
            onClick={() => onClick("Nobel Link")}
          >
            <FaLink /> Nobel Link
          </div> */}
        </>
      ) : (
        <>
          <div
            className={`sidebar-item ${
              activePage === "Dashboard" ? "active" : ""
            }`}
            onClick={() => onClick("Dashboard")}
          >
            <FaTachometerAlt /> Dashboard
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Clients" ? "active" : ""
            }`}
            onClick={() => onClick("Clients")}
          >
            <FaShoppingCart /> Clients
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Action Items" ? "active" : ""
            }`}
            onClick={() => onClick("Action Items")}
          >
            <FaFileAlt /> Action Items
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Help Center" ? "active" : ""
            }`}
            onClick={() => onClick("Help Center")}
          >
            <FaQuestionCircle /> Help Center
          </div>
          <div
            className={`sidebar-item ${
              activePage === "Nobel Link" ? "active" : ""
            }`}
            onClick={() => onClick("Nobel Link")}
          >
            <FaLink /> Nobel Link
          </div>
        </>
      )}
    </div>
  );
};

const HomePage = () => {
  const { user } = useContext(UserContext);

  const [activePage, setActivePage] = useState(
    user.role === "medical" ? "Active Requests" : "Dashboard"
  );
  const navbarRef = useRef(null);

  const handleSidebarClick = (page) => {
    setActivePage(page);
  };

  useLayoutEffect(() => {
    if (navbarRef.current) {
      const h = navbarRef.current.getBoundingClientRect().height;
      document.documentElement.style.setProperty("--navbar-height", `${h}px`);
    }
  }, []);

  return (
    <div className="home-page">
      <Navbar isTemplate={true} showLogo={false} ref={navbarRef} />
      <Sidebar
        role={user?.role}
        onClick={handleSidebarClick}
        activePage={activePage}
      />
      <div className="main-content">{renderActivePage(activePage)}</div>
    </div>
  );
};

export default HomePage;
